<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/logo-teman-bakat.png"
          height="90px"
          alt="logo"
        />
      </section>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/aggression/Agresivitas-Label0.png"
          height="90px"
          alt="label"
        />
      </section>
      <v-card
        class="mb-2 mx-2 pr-2 d-flex justify-center rounded-max"
        color="purple"
      >
        <div id="chart"></div>
      </v-card>

      <section class="pa-3">
        <div class="d-flex mb-3" v-for="(item, key) in result.rs" :key="key">
          <section class="mr-2">
            <div class="code d-flex justify-center align-center">
              <strong>{{ key }}</strong>
            </div>
          </section>
          <section>
            <section>
              <p class="mb-1 purple--text">
                <strong>{{ item.kategori }}</strong>
              </p>
            </section>
            <section>{{ item.deskripsi }}</section>
          </section>
        </div>
      </section>
      <section class="pa-3" v-if="result">
        <p class="purple--text">
          <strong>Deskripsi :</strong>
        </p>
        <v-card class="pa-3 mb-2" v-if="result.total_score">
          <p>{{ result.total_score.tingkat.deskripsi }}</p>
        </v-card>
      </section>
    </div>
    <UiDownload />
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import UiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { UiDownload },
  name: "resultAgression",
  data() {
    return {
      result: "",
      pyramid: {},
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let data = JSON.parse(localStorage.getItem("tesemosi"));
    this.result = JSON.parse(data.result);
    let dataChart = this.result.rs;
    let keys = [];
    let val = [];
    for (let key in dataChart) {
      val.push(dataChart[key].score);
      keys.push(key);
    }
    setTimeout(() => {
      this.getChart(keys, val);
    }, 100);
  },
  methods: {
    getChart(key, val) {
      var options = {
        series: [
          {
            name: "Value",
            data: val,
          },
        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },
        colors: ["#fff"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: key,
          labels: {
            style: {
              colors: "#fff",
            },
          },
        },
        yaxis: {
          tickAmount: 5,
          min: 0,
          max: 5,
          labels: {
            style: {
              colors: "#fff",
            },
          },
        },
      };

      var chart = new ApexCharts(document.querySelector("#chart"), options);
      chart.render();
    },
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.type {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.rounded-max {
  border-radius: 15px;
}
.code {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #1e656c;
  color: white;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
</style>
